import React from 'react';

import { enquote } from '~/eds/src/utils/enquote';
import { Field } from '~/evifields/src/types/Field';
import { Filter } from '~/evifields/src/types/Filter';
import { TextValue } from '~/evifields/src/types/Value';
import { DOCUMENT_ID_FILTER } from '~/features/filters/constants';

import { TextContainer } from '../TextContainer';

interface Props {
  filter: Filter<TextValue>;
  field: Field;
}

export const TextValuesPreview = ({ field, filter }: Props) => {
  const value = filter.values[0] ?? '';
  let text = enquote(value);

  if (field.label === DOCUMENT_ID_FILTER) {
    const ids = value.split(',');
    text = ids.length > 1 ? `of ${ids.length} values` : `of ${value}`;
  }

  return <TextContainer text={text} />;
};
